module.exports = __webpack_public_path__ + "static/media/p3.bc2d5349.jpg";